import React from 'react';
import { createFormatters } from 'app/infrastructure/data/date';
import { ButtonCallToAction, ButtonTertiary } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import * as navigate from 'app/area/shared/navigation';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { getBackRoute } from '../route';
import { FavoriteStickyHeaderProps } from '../types';
import { ReportPanel } from 'app/area/favourite-administration/form/components/report-panel';
import { FavouriteEditMenu } from 'app/area/favourite-administration/form/components/favourite-edit-menu';
import { canDelete } from 'app/area/favourite-administration/form/components/helpers';
import styles from './favourite-sticky-header.scss';

export const FavouriteStickyHeader: React.FC<FavoriteStickyHeaderProps> = ({
  favouriteItem, name, deleting, translation, locale, onSave, onDelete
}) => {

  const formatters: any = createFormatters(locale);

  const created = isDisabled(favouriteItem.disabled);

  const updatingItem = isDefinedIncludingZero(favouriteItem?.id);

  const onCancel = () => {
    navigate.to({ pathname: getBackRoute() });
  };

  return <>
    <StickyHeader
      className={styles.header}
      rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary
            id="favourite-form-sticky-header-cancel-button"
            onClick={onCancel}>
            {translation.cancel}
          </ButtonTertiary>
          <ButtonCallToAction
            id="favourite-form-sticky-header-save-button"
            onClick={onSave}
            disabled={false}>
            {translation.update}
          </ButtonCallToAction>
        </StickyHeaderButtonContainer>

        {canDelete(favouriteItem.id)
          ? <FavouriteEditMenu
            id={favouriteItem.id}
            translation={translation}
            onDelete={onDelete}
            fetching={deleting}
          /> : null}

      </>} >
      <div className={styles.headerContainer}>
        {updatingItem ? <span className={styles.headerId}>
          #{favouriteItem.id}
        </span> : null}
        <h2 className={styles.headerTitle}>
          {updatingItem
            ? name || null
            : null}
        </h2>
        {(favouriteItem.sharedWithUserGroups.length > 0 || favouriteItem.sharedWithUsers.length > 0)
          ? <Tag className={styles.tag}>{translation.shared}</Tag>
          : null}
        {created ? <Tag>{translation.disabled}</Tag> : null}
      </div>

      <ReportPanel
        data={favouriteItem}
        translation={translation}
        formatters={formatters} />
    </StickyHeader>
  </>;
};
